// Module
var code = "<script>let $ctrl</script> <molecule-panel-error error-type=\"$ctrl.errorType()\" error-box-type=\"fixed\"></molecule-panel-error> <molecule-form-edit save=\"$ctrl.save\"> <organ-edit-panel-nextcloud-backups nextcloud=\"$ctrl.nextcloud\"></organ-edit-panel-nextcloud-backups> </molecule-form-edit> ";
// Exports
module.exports = code;